import apiWorker from '../apiWorker'

const divisions = {
    update    : (division_id, data)   => apiWorker('patch',  `/api/v1/core/divisions/${division_id}`, data, true),
    create    : (data)                => apiWorker('post',   `/api/v1/core/divisions`, data),
    find      : (query)               => apiWorker('get',    `/api/v1/core/divisions${query}`),
    findById  : (division_id)         => apiWorker('get',    `/api/v1/core/divisions/${division_id}`, null, true),
}

export default divisions;